// DAY-DIRECTSTAFF-2026-11-08 §4: Numbers on one printable page (desktop) -- the section as it is on screen, copied into a new tab
// laid out in two columns on one Letter page, then the print dialog. Nothing is counted again: it is the same HTML. The new tab
// stays open after printing, so it can be screenshotted as well.

/** a page's HTML: the title line, then the copied section, in two columns on one Letter page */
export function onePageHtml({ title, when, body }) {
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
  return `<!doctype html><html lang="en"><head><meta charset="utf-8"><title>${esc(title)}</title><style>
@page { size: letter portrait; margin: 8mm; }
html, body { background: #fff; }
body { margin: 0 auto; padding: 8px; max-width: 1040px; font: 10px/1.25 system-ui, -apple-system, "Segoe UI", sans-serif; color: #0f172a; }
.sheet-head { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 2px solid #0f172a; padding: 0 0 4px; margin: 0 0 6px; }
.sheet-head h1 { font-size: 15px; margin: 0; }
.sheet-head span { font-size: 10px; color: #475569; }
.sheet { columns: 2; column-gap: 16px; }
.sheet > section { display: contents; }
.sheet > section > * { break-inside: avoid; }
.sheet h3 { display: none; }
.sheet h4 { font-size: 11.5px !important; margin: 0 0 2px !important; }
.sheet p, .sheet dl { font-size: 10px !important; margin: 2px 0 !important; }
.sheet div[data-testid^="numbers-"] { margin-top: 6px !important; }
.sheet [role="region"] { overflow: visible !important; }
.sheet table { width: 100% !important; }
.sheet th, .sheet td { padding-top: 1px !important; padding-bottom: 1px !important; padding-right: 4px !important; font-size: 10px !important; line-height: 1.2 !important; }   /* the left padding stays: sub-rows indented */
.sheet th div { font-size: 9px !important; }
.sheet button { display: none !important; }
@media print { body { padding: 0; max-width: none; } }
</style></head><body><div class="sheet-head"><h1>${esc(title)}</h1><span>${esc(when)}</span></div><div class="sheet">${body}</div></body></html>`;
}

/** the section's HTML for the page: buttons, "How these are counted" and anything marked data-no-print left out */
export function printableBody(node) {
  const copy = node.cloneNode(true);
  copy.querySelectorAll('button, details, [data-no-print]').forEach((el) => el.remove());
  return copy.outerHTML;
}

/** opens the page in a new tab and its print dialog -> true | false (the browser blocked the tab) */
export function printOnePage(node, { title = 'Numbers', when = '', win = window } = {}) {
  const w = win.open('', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(onePageHtml({ title, when, body: printableBody(node) }));
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { /* the page stays open to screenshot */ } }, 250);
  return true;
}
